// extracted by mini-css-extract-plugin
export default {"Container":"LoginCallback_Container__WKo2J"};